import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBbb = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "6.9 6.32 375 375",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("circle", {
			cx: 194.4,
			cy: 193.82,
			r: 187.5,
			fill: "#0b205c"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M137.55,239.74l2.45-2.45,20.29-20.29,29.43-29.43c16.39-16.39,24.64-38.12,24.64-59.3s-8.25-42.92-24.64-59.3l-15.38-15.38h-.11c8.14,13.49,12.04,28.43,12.04,43.36,0,21.18-8.25,42.92-24.64,59.3l-18.84,18.84c-3.9-9.59-5.8-19.73-5.8-29.88,0-12.6,2.9-25.08,8.25-36.68l-10.14,10.59c-16.39,15.94-24.64,38.01-24.64,59.3s8.25,42.92,24.64,58.86l2.45,2.45Z",
			fill: "#007bc8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M292.38,264.15h-65.32l26.87-26.87c15.83-15.94,24.08-37.12,24.08-58.86s-8.14-43.36-24.08-59.3l-15.68-15.13c8.03,12.98,11.89,27.82,11.89,42.66,0,21.74-8.25,42.92-24.64,59.3-18.78,18.78-38.06,38.46-57.75,58.19h-71.34c-3.76,0-6.8,3.04-6.8,6.8v21.18c0,3.76,3.04,6.8,6.8,6.8h195.97c3.76,0,6.8-3.04,6.8-6.8v-21.18c0-3.76-3.04-6.8-6.8-6.8Z",
			fill: "#007bc8"
		})
	]
});
const ForwardRef = forwardRef(SvgBbb);
export { ForwardRef as ReactComponent };
